export default {
    title: 'Macro-trend:',
    belongs: 'This macro-trend belongs to the mega-trend:',
    action: 'Speichern',
    back: 'Overview',
    microtrends: 'Micro-trends',
    feedback: 'Thank you for your review',
    pageTitle: 'TRENDRADAR - REVIEW - PARTICIPATION'
}
